/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanBarcodeClassicIcon24Solid = forwardRef('ScanBarcodeClassicIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M5.002 5.25a1 1 0 0 0-2 0v13.5a1 1 0 1 0 2 0V5.25Z" }),
        React.createElement("path", { d: "M7.202 4.25a1 1 0 0 1 1 1v11.186a1 1 0 1 1-2 0V5.25a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M11.4 5.25a1 1 0 1 0-2 0v11.186a1 1 0 1 0 2 0V5.25Z" }),
        React.createElement("path", { d: "M13.6 4.25a1 1 0 0 1 1 1v13.5a1 1 0 1 1-2 0V5.25a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M17.8 5.25a1 1 0 0 0-2 0v11.186a1 1 0 1 0 2 0V5.25Z" }),
        React.createElement("path", { d: "M20.999 5.25a1 1 0 1 0-2 0v13.5a1 1 0 1 0 2 0V5.25Z" })));
});
